module.exports = __webpack_public_path__ + "static/img/safe-bg-ipad.40e2df44.png";